import React from 'react';
import './social-share.scss'
import config from './../../config'

const SocialShare = ({ image, title, currentPath }) => (
  <div className="social-share__container">
    <div className="social-share__wrapper">
      <div className="social-share__title">You can save or share this article:</div>
      <amp-social-share class="social-share__item" data-param-app_id="295182704556303" type="facebook" />
      <amp-social-share class="social-share__item" type="twitter" />
      <amp-social-share class="social-share__item" type="pinterest" data-param-media={config.siteUrl + image} data-param-url={config.siteUrl + currentPath} data-param-description={title} />
    </div>
  </div>
);

export default SocialShare



// WEBPACK FOOTER //
// ./src/components/social-share/social-share.js